import { Trans, useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { Link } from "react-router-dom";

import type { AppModel } from "../../../app/app-model";

import { Button } from "../../../components/ui-kit/button";
import { ErrorMessage } from "../../../components/ui-kit/error-message";
import { PasswordInput } from "../../../components/ui-kit/fields/password-input";
import { TextInput } from "../../../components/ui-kit/fields/text-input";
import { Form } from "../../../components/ui-kit/form/form";

export function PasswordLogin(props: {
  app: AppModel;
  onEmailLogin: () => void;
}) {
  const { t } = useLingui();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit() {
    setError("");
    try {
      await props.app.seerlinqApi.login(username, password);
    } catch {
      setError(t`Incorrect username or password`);
    }
  }

  return (
    <Form className="flex flex-col" onSubmit={handleSubmit}>
      <div className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-3 items-center">
        <label>
          <Trans>Username:</Trans>
        </label>
        <TextInput
          value={username}
          onChange={(newValue) => {
            setUsername(newValue);
          }}
          autoFocus
        />
        <label>
          <Trans>Password:</Trans>
        </label>
        <PasswordInput
          value={password}
          onChange={(newValue) => {
            setPassword(newValue);
          }}
        />
      </div>

      <ErrorMessage message={error} />

      <div className="flex items-center justify-between mt-6">
        <div className="flex flex-col gap-2">
          <Link
            to="/forgot-password"
            className="text-xs text-brand-primary hover:underline"
          >
            <Trans>Forgot password?</Trans>
          </Link>
          <a
            onClick={props.onEmailLogin}
            className="text-xs text-brand-primary hover:underline cursor-pointer"
          >
            <Trans>Log in with email link</Trans>
          </a>
        </div>

        <Button type="submit">
          <Trans>Log In</Trans>
        </Button>
      </div>
    </Form>
  );
}
